import { SVGProps } from "react";
import styles from "../variants/01/sw-categories-variant-01.module.scss";

export const CategoryMonovolumeSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 756.3 303.1"
    style={{
      // @ts-ignore
      enableBackground: "new 0 0 756.3 303.1",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      className={styles.st0}
      d="M146.6 200.3c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.9-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.2-60.9-60.9-60.9zM631.8 200.3c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9z"
    />
    <path
      className={styles.st0}
      d="M751.2 188.2c-3.5 0-6.8-2.1-8.3-5.3l-18.7-40.5c-3.8-8.3-10.9-14.8-19.5-18l-100-36.6L426.2 0H74.1v16.6l-55.7 100-8.8 76.2-9.6 4.8V232c0 6.3 2.4 12 7.2 16.6 15.1 14.8 50 16.7 61.7 16.9h3.8l1.5.1c-.6-1.7-1-3.3-1.5-5.1-1.5-5.9-2.2-12-2.2-18.4 0-42 34.2-76.2 76.2-76.2s76.2 34.2 76.2 76.2c0 8.7-1.5 17-4.1 24.8-.6 1.7-1.2 3.4-1.9 5h343.3l1.6-.1c-.7-1.6-1.3-3.2-1.9-4.9-2.7-7.8-4.1-16.1-4.1-24.8 0-42 34.2-76.2 76.2-76.2s76.2 34.2 76.2 76.2c0 5.1-.5 10-1.5 14.9-.3 1.7-.7 3.4-1.2 5h18.4c18 0 32.6-14.6 32.6-32.6v-36.2c-.2-2.7-2.5-5-5.3-5zm.1 41.3c0 15.2-12.4 27.6-27.6 27.6h-12.1c.9-4.8 1.4-9.8 1.4-14.9 0-44.8-36.4-81.2-81.2-81.2s-81.2 36.4-81.2 81.2c0 8.6 1.3 16.9 3.9 24.8H223.9c2.5-7.8 3.9-16.1 3.9-24.8 0-44.8-36.4-81.2-81.2-81.2s-81.2 36.4-81.2 81.2c0 6.3.7 12.4 2.1 18.3-12.3-.4-43.8-2.6-56.9-15.4C6.9 241.3 5 237 5 232v-31.4l9.2-4.6 9-77.9L79.1 17.9V5h346l177.6 87.3.1.1 100.3 36.7c7.3 2.7 13.4 8.3 16.6 15.4l18.7 40.5c2.3 5 7.3 8.2 12.8 8.2 0 0 .1 0 .1.1v36.2z"
    />
    <path
      className={styles.st0}
      d="M218.8 21.4c1.4 4.5 5.1 22.4.8 79.1L92.6 96s-2.9-.4-6-2.2c-3.3-1.9-4.5-6.1-2.6-9.4 8.7-15.3 40.7-63.1 100.7-63.1h34.1zM355 21.4c8.6 20.1 9.2 67.9 9.2 84.1l-123.6-4.3c-.3-12.4-1.5-64.5 1.1-79.8H355zM548 83.7c-9.5-.1-28.3 2.1-21.8 22.4.8 2.5-1 5-3.6 4.9l-135.9-4.7c-4.7-23.4-9.1-84.9-9.1-84.9h38.1c4.2 0 8.4.5 12.5 1.6 20.5 5.5 85.3 24.7 121.1 57.3 1.3 1.2.5 3.4-1.3 3.4z"
    />
  </svg>
);
